import React, { Component } from "react"
import { connect } from "react-redux"

import IconButton from "@mui/material/IconButton"
import VisibilityIcon from "@mui/icons-material/Visibility"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"

import Tooltip from '@mui/material/Tooltip'

class PasswordField extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hidden: true,
      password: ""
    }

    this.handlePasswordChange = this.handlePasswordChange.bind(this)
    this.toggleShow = this.toggleShow.bind(this)
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value })

    // NEW set focus to password field
    document.getElementById("password").focus()
  }

  toggleShow() {
    this.setState({ hidden: !this.state.hidden })
  }

  componentDidMount() {
    if (this.props.password) {
      this.setState({ password: this.props.password })
    }
  }

  render() {
    const { input, label, autoComplete, spellCheck, hint, meta } = this.props

    // NEW find jump in increase in length of password
    // big jumps can be due to password manager, or pasting a password in to field
    const inputLength = input.value ? input.value.length : 0
    const passwordLength = this.state.password ? this.state.password.length : 0
    const passwordJump = passwordLength - inputLength

    input.value = this.state.password // NEW set input value

    // NEW change focus away from password field after 10msecs pause
    // this triggers correct validation and use of form field
    if (passwordJump >= 8) { // 8 is minimum length of a valid password
      const pwField = document.getElementById("password")
      if (pwField) setTimeout(() => { pwField.blur() }, 10)
    }

    return (
      <div className="control">
        <label htmlFor={input.name} >{label}</label>

        <div style={{ display: "flex" }}>
          <input {...input}
            id="password"
            type={this.state.hidden ? "password" : "text"}
            value={input.value}
            onChange={this.handlePasswordChange}
            autoComplete={autoComplete}
            spellCheck={spellCheck}
          />

          <IconButton
            onClick={this.toggleShow}
            className="show password"
          >
            {this.state.hidden &&
              <Tooltip title="show password">
                <VisibilityIcon />
              </Tooltip>}

            {!this.state.hidden &&
              <Tooltip title="hide password">
                <VisibilityOffIcon />
              </Tooltip>}
          </IconButton>
        </div>

        {hint
          ? <div className={"password-hint" + (meta.dirty && meta.error ? " password-hint-error" : "")}>{hint}</div>
          : <div className="error-message">{meta.dirty && meta.error}</div>
        }
      </div>
    )
  }
}

export default connect(
  state => ({
    password: state.password,
  }),
)(PasswordField)